// extracted by mini-css-extract-plugin
module.exports = {"inner":"Posts_inner__mcVnh","content":"Posts_content__LDr7f"};